<template lang="pug">
  .message(:style="{ margin: messageMargin }")
    .title(:style="{ fontSize: fontSizes[0] + 'px' }") {{ title }}
    .subtitle(:style="{ fontSize: fontSizes[1] + 'px' }") {{ subtitle }}
    b-button.action(
      :style="{ fontSize: fontSizes[2] + 'px', padding: buttonPadding }"
      variant='primary',
      text='Primary',
      v-if="button",
      @click="$router.push(routerLink({ page: 'About', name: 'About Us', section: 'contact' }))"
    ) {{ button }}
</template>
<script type="text/javascript">
export default {
  name: 'Message',
  computed: {
    buttonPadding () {
      return this.fontSizes[2] + 'px ' + this.fontSizes[2] * 1.8 + 'px'
    },
    messageMargin () {
      return this.fontSizes[0] + 'px ' + this.fontSizes[1] + 'px'
    }
  },
  methods: {
    routerLink (link) {
      if (!link.section) {
        return { name: link.page}
      } else {
        return { name: link.page, query: { section: link.section }}
      }
    }
  },
  props: {
    button: {
      type: String,
      default: null
    },
    fontSizes: {
      type: Array,
      default: () => ([ 50, 24, 16 ])
    },
    subtitle: {
      type: String,
      default: 'Placeolder'
    },
    title: {
      type: String,
      default: 'Placeholder'
    }
  }
}  
</script>


<style scoped lang="scss">
$color-title: #364149;
$color-subtitle: #767F86;
.message {
  color: $color-title;
  font-style: normal;
  font-weight: bold;
  margin: 90px 0;
  .title {
    line-height: 1.2em;
    padding: 1em 0 0.65em 0;
  }
  .subtitle {
    color: $color-subtitle;
    font-style: normal;
    font-weight: normal;
    line-height: 1.33em;
  }
  .action {
    // padding: 20px 29px 17px 29px;
    margin: 47px 0;
    background: #5473E8;
    border: none;
    border-radius: 100px;
    font-style: normal;
    font-weight: bold;
    line-height: 18px;
    display: flex;
    align-items: flex-end;
    text-align: center;
    text-transform: uppercase;
  }
}
</style>